module.exports = __webpack_public_path__ + "static/media/Sanomat Grab Web-Light Italic TH.2017efa5.eot";